import { render } from "./Thoughts.vue?vue&type=template&id=673443a6"
import script from "./Thoughts.vue?vue&type=script&lang=js"
export * from "./Thoughts.vue?vue&type=script&lang=js"

import "./Thoughts.vue?vue&type=style&index=0&id=673443a6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__